export default __webpack_public_path__ + "static/media/Agrata Dwivedi.477ecbc0.jpg";